export const SuccesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <circle
        cx="15"
        cy="15"
        r="14"
        transform="rotate(90 15 15)"
        fill="#006217"
        stroke="#006217"
        strokeWidth="2"
      />
      <path
        d="M7.20312 15.3443L12.177 20.3996L22.8031 9.59961"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
